import { combineReducers } from 'redux';

import {
  REPORTS_TRANSACTIONS_SET_ORDERS_BY_DATE,
  REPORTS_TRANSACTIONS_SET_ORDER_SUMMARY,
  REPORTS_TRANSACTIONS_SET_NEXT_CURSOR,
  REPORTS_TRANSACTIONS_SET_HAS_MORE,
  REPORTS_TRANSACTIONS_SET_OUTLET_BY_ID,
  REPORTS_TRANSACTIONS_SET_PAYMENT_METHODS,
  REPORTS_TRANSACTIONS_SET_ORDER_DETAIL,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
} from '../../actions/reports/transactionsv2/constants';
import createReducer from '../../utils/createReducer';

const orderSummary = createReducer(
  {},
  {
    [REPORTS_TRANSACTIONS_SET_ORDER_SUMMARY]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.orderSummary,
  }
);

const ordersByDate = createReducer(
  {},
  {
    [REPORTS_TRANSACTIONS_SET_ORDERS_BY_DATE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.ordersByDate,
  }
);

const nextCursor = createReducer('', {
  [REPORTS_TRANSACTIONS_SET_NEXT_CURSOR]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.nextCursor,
});

const hasMore = createReducer(false, {
  [REPORTS_TRANSACTIONS_SET_HAS_MORE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.hasMore,
});

const outletById = createReducer(
  {},
  {
    [REPORTS_TRANSACTIONS_SET_OUTLET_BY_ID]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.outletById,
  }
);

const paymentMethods = createReducer([], {
  [REPORTS_TRANSACTIONS_SET_PAYMENT_METHODS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.paymentMethods,
});

const orderDetail = createReducer(null, {
  [REPORTS_TRANSACTIONS_SET_ORDER_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.orderDetail,
});

const refundBreakdown = createReducer(
  {
    refundItems: [],
    refundItemsPromo: [],
  },
  {
    [REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS]: (
      draft,
      { payload }
    ) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.refundItems = payload.items;
    },

    [REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO]: (
      draft,
      { payload }
    ) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.refundItemsPromo = payload.itemsPromo;
    },
  }
);

export default combineReducers({
  hasMore,
  nextCursor,
  outletById,
  ordersByDate,
  orderSummary,
  paymentMethods,
  orderDetail,
  refundBreakdown,
});
